import {
  Smartphone, Phone, MessageCircle, Globe, CalendarDays, MapPin, Linkedin, AtSign, Instagram, Palette,
  Facebook, Music2, Ghost, Youtube, Dribbble, Github, Send, Link2, Mail, Type,
} from "lucide-react";

export const FIELD_ICONS = {
  phone: Smartphone, office_phone: Phone, whatsapp: MessageCircle, website: Globe, calendar: CalendarDays,
  office_location_en: MapPin, office_location_ar: MapPin, linkedin: Linkedin, twitter: AtSign,
  instagram: Instagram, behance: Palette, facebook: Facebook, tiktok: Music2, snapchat: Ghost,
  youtube: Youtube, dribbble: Dribbble, github: Github, telegram: Send,
};

const TYPE_ICONS = { url: Link2, tel: Phone, email: Mail };

export const fieldIcon = (f) => FIELD_ICONS[f.key] || TYPE_ICONS[f.type] || Type;

export const GROUP_LABELS = {
  contact: { en: "Contact", ar: "التواصل" },
  business: { en: "Business", ar: "العمل" },
  social: { en: "Social media", ar: "التواصل الاجتماعي" },
};

export const fieldLabel = (f, lang) => (lang === "ar" ? f.label_ar : f.label_en);

export const displayUrl = (url) => url.replace(/^https?:\/\/(www\.)?/i, "").replace(/\/$/, "");

export const groupFields = (fields) =>
  ["contact", "business", "social"].map((g) => [g, fields.filter((f) => f.group === g)]).filter(([, list]) => list.length);
